import React from "react";
import {useSelector, shallowEqual} from "react-redux";
import {format} from "date-fns";
import Barcode from "react-barcode";
import RenderIf from "app/components/RenderIf";
import {findTicketBetType} from "../../Play/helpers";
import "../styles/ticket.css";
import "./print.css";

const printedAgainTypes = {
    0: "isSalePrintAllowed",
    2: "isWinPrintAllowed",
    3: "isLostPrintAllowed",
    4: "isCancelPrintAllowed"
};

export const TicketPrint = React.forwardRef((props, ref) => {
    const {printData, isWinningPaid, isCancelled} = useSelector(
        (state) => state.ticket,
        shallowEqual
    );

    return (
        <div className="containerWrapper w-100">
            <div ref={ref} className="container">
                {Object.keys(printData).length ? (
                    <div className="col-12 pl-6 pr-6 pt-6">
                        <div className="d-flex justify-content-center">
                            <img src="/media/logos/1x2-logo.svg" alt="1x2" className="logo"/>
                        </div>
                        <div className="divider"></div>
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12 p-0">
                                <div className="w-100 pt-2 pb-2 pt-2 d-flex justify-content-between flex-wrap">
                                    <span className="text">Bilet ID:</span>
                                    <span className="text">{printData.id}</span>
                                </div>
                                <div className="w-100 pt-2 pb-2 pt-2 d-flex justify-content-between flex-wrap">
                                    <span className="text">Məhsul:</span>
                                    <span className="text">{printData.productName}</span>
                                </div>
                                <div className="w-100 pt-2 pb-2 pt-2 d-flex justify-content-between flex-wrap">
                                    <span className="text">Tur nömrəsi:</span>
                                    <span className="text">{printData.circulationNumber}</span>
                                </div>
                                <div className="w-100 pt-2 pb-2 pt-2 d-flex justify-content-between flex-wrap">
                                    <span className="text">ID:</span>
                                    <span className="text">
                    {printData.customerNumber
                        ? `${printData.customerNumber.substring(0, 7)}*****`
                        : printData.agentNumber}
                  </span>
                                </div>
                                <div className="w-100 pt-2 pb-2 pt-2 d-flex justify-content-between flex-wrap">
                                    <span className="text">Agent ID:</span>
                                    <span className="text">{printData.agentNumber}</span>
                                </div>
                                <div className="w-100 pt-2 pb-2 pt-2 d-flex justify-content-between flex-wrap">
                                    <span className="text">Yaradılma tarixi:</span>
                                    <span className="text">
                    {printData.createdDate &&
                        format(
                            new Date(printData.createdDate),
                            "dd.MM.yyyy HH:mm:ss"
                        )}
                  </span>
                                </div>
                            </div>
                            <div className="games">
                                {printData.ticketGames.map((game, index) => (
                                    <div className="game" key={index}>
                                        <div className="gameTitle">
                                            <div>
                                                {index + 1}. {game.hostClub} - {game.guestClub}
                                            </div>
                                            <div className="startDate">
                                                {format(new Date(game.startDate), "dd/MM/yy HH:mm")}
                                            </div>
                                        </div>
                                        <div className="gameDescription">
                      <span>
                        proqnoz: {game.options.option1 ? "1" : ""}
                          {game.options.optionX ? "X" : ""}
                          {game.options.option2 ? "2" : ""}
                      </span>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <RenderIf
                                condition={
                                    isWinningPaid ||
                                    printData.winningPaidStatus ||
                                    printData[printedAgainTypes[printData.statusId]] ||
                                    isCancelled ||
                                    printData.statusId === 4 ||
                                    printData.statusId === 3
                                }
                            >
                                <div className="d-flex justify-content-center align-items-stretch w-100 mt-4">
                                    <RenderIf condition={printData.statusId === 3}>
                                        <div
                                            style={{
                                                border: "3px solid #000",
                                                borderRadius: "8px",
                                                padding: "16px 26px",
                                                fontWeight: "bold",
                                                fontFamily: "Poppins",
                                                fontSize: "15px",
                                            }}
                                            className="mr-2 borderedText"
                                        >
                                            <span className="text ">UDUŞSUZ</span>
                                        </div>
                                    </RenderIf>
                                    <RenderIf condition={isCancelled || printData.statusId === 4}>
                                        <div
                                            style={{
                                                border: "3px solid #000",
                                                borderRadius: "8px",
                                                padding: "16px 26px",
                                                fontWeight: "bold",
                                                fontFamily: "Poppins",
                                                fontSize: "15px",
                                            }}
                                            className="mr-2 borderedText"
                                        >
                                            <span className="text ">LƏĞV EDİLİB</span>
                                        </div>
                                    </RenderIf>
                                    <RenderIf
                                        condition={isWinningPaid || printData.winningPaidStatus}
                                    >
                                        <div
                                            style={{
                                                border: "3px solid #000",
                                                borderRadius: "8px",
                                                padding: "16px 26px",
                                                fontWeight: "bold",
                                                fontFamily: "Poppins",
                                                fontSize: "15px",
                                            }}
                                            className="mr-2 borderedText"
                                        >
                                            <span className="text ">ÖDƏNİLİB</span>
                                            <span className="text">
                        {printData?.winningAmount} AZN
                      </span>
                                        </div>
                                    </RenderIf>
                                    <RenderIf
                                        condition={printData[printedAgainTypes[printData.statusId]]}
                                    >
                                        <div
                                            style={{
                                                border: "3px solid #000",
                                                borderRadius: "8px",
                                                padding: "16px 26px",
                                                fontWeight: "bold",
                                                fontFamily: "Poppins",
                                                fontSize: "15px",
                                            }}
                                            className="borderedText"
                                        >
                                            <span className="text">TƏKRAR ÇAP</span>
                                        </div>
                                    </RenderIf>
                                </div>
                            </RenderIf>
                            <div className="divider"></div>
                            <div className="w-100 d-flex justify-content-between flex-wrap">
                <span className="text">
                  <b>Mərc tipi:</b>
                </span>
                                <span className="text">
                  <b>{findTicketBetType(printData?.ticketGames)}</b>
                </span>
                            </div>
                            <div className="divider"></div>
                            <div className="w-100 d-flex justify-content-between flex-wrap">
                <span className="text">
                  <b>Yekun mərc məbləği:</b>
                </span>
                                <span className="text">
                  <b>{`${printData.price} AZN`}</b>
                </span>
                            </div>
                            <div className="divider"></div>
                            <div className="w-100 d-flex justify-content-between flex-wrap">
                                <span className="text"><b>Misli:</b></span>
                                <span className="text"><b>{printData.times}</b></span>
                            </div>
                            <div className="divider"></div>
                        </div>
                        <RenderIf
                            condition={
                                props.isScanner ||
                                printData?.isWinPrintAllowed ||
                                printData?.isSalePrintAllowed ||
                                printData?.isCancelPrintAllowed ||
                                printData?.isLostPrintAllowed
                            }
                        >
                            <div className="barcode">
                                <Barcode
                                    {...{width: 7, fontSize: 40, height: 250}}
                                    value={printData.ticketNumber}
                                />
                            </div>
                        </RenderIf>
                        <RenderIf condition={printData.isJackpot}>
                            <p className="jackpot">
                                CEKPOT MƏBLƏĞİ: {printData.jackpotAmount}
                            </p>
                        </RenderIf>
                    </div>
                ) : (
                    ""
                )}
            </div>
        </div>
    );
});
